<template>
  <div class="columnBox">
    <div class="infoBox">
      <van-cell-group inset>
        <van-field readonly v-model="state.printData.company_name" label="公司"/>
        <van-field readonly v-model="state.printData.vendor_name" label="供应商"/>
        <van-field readonly v-model="state.printData.delivery_date" label="预计交货日期"/>
        <van-field readonly v-model="state.printData.memo" label="抬头文本"/>
      </van-cell-group>
    </div>
    <div class="date-edit-box">
      <van-cell-group inset>
        <van-field
            v-model="state.documentDate"
            clickable
            label="凭证日期"
            placeholder="请选择凭证日期"
            readonly
            required
            @click="showDocumentDate = true"
        />
        <van-field
            v-model="state.postingDate"
            clickable
            label="过账日期"
            placeholder="请选择过账日期"
            readonly
            required
            @click="showPostingDate = true"
        />
        <van-field
            v-model="state.remark"
            autosize
            clearable
            label="备注"
            placeholder="请输入备注"
            rows="2"
            type="textarea"
        />
      </van-cell-group>
    </div>

    <van-popup v-model:show="showDocumentDate" position="bottom">
      <van-datetime-picker
          v-model="documentDateValue"
          title="选择凭证日期"
          type="date"
          @cancel="showDocumentDate = false"
          @confirm="onDocumentDateConfirm"
      />
    </van-popup>

    <van-popup v-model:show="showPostingDate" position="bottom">
      <van-datetime-picker
          v-model="postingDateValue"
          title="选择过账日期"
          type="date"
          @cancel="showPostingDate = false"
          @confirm="onPostingDateConfirm"
      />
    </van-popup>

    <van-popup v-model:show="showWarehousePicker" position="bottom">
      <van-picker
          :columns="warehouseColumns"
          show-toolbar
          title="选择仓库"
          @cancel="showWarehousePicker = false"
          @confirm="onWarehouseConfirm"
      />
    </van-popup>
    <div class="tableBox">
      <div class="table-title">收货明细</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
          <tr>
            <th>序号</th>
            <th>物料编码</th>
            <th>物料名称</th>
            <th>规格型号</th>
            <th>规格描述</th>
            <th>计量单位</th>
            <th>机种</th>
            <th>收货数量</th>
            <th>工厂</th>
            <th>仓库</th>
            <th>PR成本中心</th>
            <th>备注</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in state.tableData" :key="index">
            <td>{{ item.po_item_number }}</td>
            <td>{{ item.inventory_code }}</td>
            <td>{{ item.inventory_name }}</td>
            <td>{{ item.spec }}</td>
            <td>{{ item.sub_memo }}</td>
            <td>{{ item.measuring_unit_code }}</td>
            <td>{{ item.model_code }}</td>
            <td>{{ item.delivery_quantity }}</td>
            <td>{{ item.prCostCenter }}</td>
            <td>{{ item.factory_name }}</td>
            <td>
              <span
                  :class="{ 'required-error': isWarehouseRequired(item) && !item.warehouse }"
                  class="editable-select"
                  @click="onWarehouseClick(index)"
              >
                {{ item.warehouse || '请选择仓库' }}
              </span>
            </td>
            <td>
              <input
                  v-model="item.remark"
                  class="editable-input"
                  placeholder="请输入备注"
              />
            </td>
          </tr>
          </tbody>
          <tfoot>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="bottom-button-bar">
      <van-button type="primary" @click="submitData()">提交</van-button>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {useRoute} from "vue-router";
import {Toast} from "vant";
import moment from "moment";
import * as dd from 'dingtalk-jsapi';
import ChangeTitle from "@/utils/changeTitle";
import {GetInboundDeliveryPrintData, GetWarehouseInfoList, SaveMovementData} from "../../api/Gps/movememt";

const route = useRoute()

const showDocumentDate = ref(false)
const showPostingDate = ref(false)
const showWarehousePicker = ref(false)
const currentWarehouseIndex = ref(-1)
const warehouseColumns = ref([])
const documentDateValue = ref(new Date())
const postingDateValue = ref(new Date())


const state = reactive({
  printData: {
    company_id: '',
    vendor_id: '',
    vendor_code: '',
    vendor_name: '',
    inbound_document_code: '',
    company_name: '',
    delivery_date: '',
    memo: '',

  },
  tableData: [],
  documentDate: moment().format('YYYY-MM-DD'),
  postingDate: moment().format('YYYY-MM-DD'),
  remark: '',
  queryParams: {
    id: '',
  },
})

const getCurrentYearMonth = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  // 月份从0开始，+1后补零处理
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  return `${year}${month}`;
}

const onDocumentDateConfirm = ({selectedValues}) => {
  state.documentDate = selectedValues.join('-')
  showDocumentDate.value = false
}

const onPostingDateConfirm = ({selectedValues}) => {
  state.postingDate = selectedValues.join('-')
  showPostingDate.value = false
}

const getMovementData = () => {
  try {
    GetInboundDeliveryPrintData({id: state.queryParams.id}).then((res)=>{
      if (res.success) {
        const data = res.data
        state.printData = {
          company_id: data[0].company_id || '',
          vendor_id: data[0].vendor_id || '',
          vendor_code: data[0].vendor_code || '',
          vendor_name: data[0].vendor_name || '',
          inbound_document_code: data[0].inbound_document_code || '',
          company_name: data[0].company_name || '',
          delivery_date: data[0].delivery_date ? moment(data[0].delivery_date).format('YYYY-MM-DD') : '',
          memo: `${getCurrentYearMonth()}采购收货`,
        }
        state.tableData = data.map(item => ({
          inbound_delivery_detail_id: item.inbound_delivery_detail_id || '',
          inbound_delivery_item_number: item.inbound_delivery_item_number || '',
          free_flag: item.free_flag,
          po_item_number: item.po_item_number || '',
          inventory_code: item.inventory_code || '',
          inventory_name: item.inventory_name || '',
          spec: item.spec || '',
          sub_memo: item.sub_memo || '',
          measuring_unit_code: item.measuring_unit_code || '',
          model_code: item.model_code || '',
          delivery_quantity: item.delivery_quantity || 0,
          movement_quantity: item.delivery_quantity || 0,
          factory_code: item.factory_code || '',
          factory_name: item.factory_name || '',
          factory_id: item.factory_id || '',
          warehouse_code: item.warehouse_code || '',
          warehouse_id: item.warehouse_id || '',
          inventory_type: item.inventory_type || '',
          warehouse: item.warehouse || '',
          prCostCenter: item.prCostCenter || '',
          remark: item.detail_remark || '',
        }))
      } else {
        Toast.fail(res.data?.msg || '加载数据失败')
      }
    })
  } catch (err) {
    Toast.fail('加载失败，请重试')
  }
}
const loadWarehouseList = (factoryId) => {
  try {
    GetWarehouseInfoList({factory_id: factoryId}).then((res)=>{
      if (res.success && res.data) {
        warehouseColumns.value = res.data.map(item => ({
          text: `${item.warehouse_code}-${item.warehouse_name}`,
          value: `${item.warehouse_code}-${item.warehouse_name}`,
        }))
      }
    })
  } catch (err) {
    console.error('加载仓库列表失败', err)
  }
}
const onWarehouseClick = (index) => {
  currentWarehouseIndex.value = index
  const row = state.tableData[index]
  warehouseColumns.value = []
  loadWarehouseList(row.factory_id)
  showWarehousePicker.value = true
}

const onWarehouseConfirm = (value) => {
  if (currentWarehouseIndex.value >= 0) {
    const val = Array.isArray(value) ? value[0] : value
    state.tableData[currentWarehouseIndex.value].warehouse = typeof val === 'object' ? val.value : val
  }
  showWarehousePicker.value = false
}
const requiredTypes = ['Z070', 'Z080', 'Z090']
const isWarehouseRequired = (item) => {
  return requiredTypes.includes(item.inventory_type)
}

const validate = () => {
  if (!state.postingDate) {
    Toast.fail('请选择过账日期')
    return false
  }
  if (!state.documentDate) {
    Toast.fail('请选择凭证日期')
    return false
  }
  for (let i = 0; i < state.tableData.length; i++) {
    const item = state.tableData[i]
    if (isWarehouseRequired(item) && !item.warehouse) {
      Toast.fail(`第${item.po_item_number}行物料类型为${item.inventory_type}，必填仓库`)
      return false
    }
  }
  return true
}

const submitData = () => {
  if (!validate()) return
  const submitParams = {
    biz_type: "A",
    company_id: state.printData.company_id,
    vendor_id: state.printData.vendor_id,
    vendor_code: state.printData.vendor_code,
    reference_document_id: state.queryParams.id,
    reference_document_code: state.printData.inbound_document_code,
    document_date: state.documentDate,
    posting_date: state.postingDate,
    memo: state.printData.memo,
    remark: state.remark,
    tableData: state.tableData
  }
  SaveMovementData(submitParams).then(res => {
    if (res.success) {
      Toast.success('提交成功')
      dd.biz.navigation.close({
        onSuccess: function () {
        },
        onFail: function () {
        },
      });
    } else {
      Toast.fail(res.data?.msg || '提交失败')
    }
  }).catch(() => {
    Toast.fail('提交异常，请重试')
  })
}

onMounted(() => {
  const loading = Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0,
  });
  ChangeTitle.setTitle("送货单")
  const {id} = route.query
  state.queryParams.id = id
  if (id) {
    getMovementData()
    loading.clear()
  } else {
    loading.clear()
    Toast.fail('缺少参数')
  }
})
</script>

<style lang="scss" scoped>
.columnBox {
  margin: 5px;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 70px;
  background: #f5f5f5;
}

.headerBox {
  background: #fff;
  padding: 15px;
  text-align: center;
  position: relative;

  .title {
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 5px 0;
    color: #333;
  }

  .sub-title {
    font-size: 16px;
    font-weight: normal;
    margin: 0 0 10px 0;
    color: #333;
  }

  .qr-code-box {
    position: absolute;
    top: 10px;
    right: 10px;

    .qr-code {
      width: 60px;
      height: 60px;
    }
  }

  .doc-no {
    text-align: left;
    font-size: 13px;
    color: #666;
    margin: 5px 0 0 0;
  }
}

.infoBox {
  margin-top: 8px;
}

.date-edit-box {
  margin-top: 8px;
}

.tableBox {
  margin-top: 8px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;

  .table-title {
    padding: 10px 12px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
  }

  .table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .data-table {
    width: 100%;
    min-width: 900px;
    border-collapse: collapse;
    font-size: 12px;

    th, td {
      border: 1px solid #e8e8e8;
      padding: 6px 8px;
      text-align: center;
      white-space: nowrap;
    }

    th {
      background: #fafafa;
      font-weight: 600;
      color: #333;
    }

    .editable-input {
      width: 80px;
      border: 1px solid #1989fa;
      border-radius: 4px;
      padding: 4px 6px;
      font-size: 12px;
      text-align: center;
      outline: none;
      background: #fff;
    }

    .editable-select {
      color: #1989fa;
      cursor: pointer;
      white-space: nowrap;
    }

    .required-error {
      color: #ee0a24;
      border-bottom: 1px solid #ee0a24;
    }
  }
}

.bottom-button-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background-color: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 10px;
  z-index: 999;
  border-top: 1px solid #f2f2f2;
}

.bottom-button-bar .van-button {
  flex: 1;
  border-radius: 8px;
}
</style>